import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FolderDto } from '@nusign/picflow-backend-types';
import { FolderService } from '../../../services/folder.service';
import { ButtonDirective } from '../../directives/button.directive';
import { ContextMenuComponent } from '../context-menu/context-menu.component';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-folder-breadcrumb',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent, ContextMenuComponent],
  templateUrl: './folder-breadcrumb.component.html',
  styleUrl: './folder-breadcrumb.component.scss',
})
export class FolderBreadcrumbComponent {
  private folderService = inject(FolderService);
  allFolders = toSignal(this.folderService.getFolders());
  folder = input.required<FolderDto>();
  selectFolder = output<FolderDto>();

  public allItems = computed<FolderDto[]>(() => {
    const folder = this.folder();
    const folders = this.allFolders();
    const items = [];
    if (!folder) return items;
    if (!folders) return;

    let currentFolder = folder;
    while (currentFolder) {
      items.unshift(currentFolder);
      currentFolder = folders.find(f => f.id === currentFolder.parent_folder);
    }

    return items;
  });

  public lastTwoItems = computed<FolderDto[]>(() => {
    const allItems = this.allItems();
    if (allItems.length <= 2) return allItems;
    return allItems.slice(-2);
  });
}
